import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const changePasswordContext = React.createContext({});
export let changePasswordMachine: any;

const MODULE_NAME = 'machines.changePassword';

export const useSMchangePassword = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  changePasswordMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(changePasswordMachine);

  return {
    changePasswordMachine,
    changePasswordState: state,
    changePasswordSend: send,
  };
};
